/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteChatExportDataDto
 */
export interface DeleteChatExportDataDto {
    /**
     * Chat export ID
     * @type {string}
     * @memberof DeleteChatExportDataDto
     */
    id: string;
    /**
     * Conversation ID
     * @type {object}
     * @memberof DeleteChatExportDataDto
     */
    conversationId: object | null;
}

/**
 * Check if a given object implements the DeleteChatExportDataDto interface.
 */
export function instanceOfDeleteChatExportDataDto(value: object): value is DeleteChatExportDataDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function DeleteChatExportDataDtoFromJSON(json: any): DeleteChatExportDataDto {
    return DeleteChatExportDataDtoFromJSONTyped(json, false);
}

export function DeleteChatExportDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteChatExportDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'conversationId': json['conversationId'],
    };
}

export function DeleteChatExportDataDtoToJSON(json: any): DeleteChatExportDataDto {
    return DeleteChatExportDataDtoToJSONTyped(json, false);
}

export function DeleteChatExportDataDtoToJSONTyped(value?: DeleteChatExportDataDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'conversationId': value['conversationId'],
    };
}

